import React from "react";
import { MdOutlineEmail } from "react-icons/md";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
const TeamCreateCard = ({ data }) => {
  return (
    <div
      className="text-black rounded-md border"
      style={{ boxShadow: "rgb(159 157 157 / 24%) 0px 3px 21px" }}>
      <div className="card-body py-5 px-4 gap-1">
        <h2 className="card-title">{data?.team}</h2>
        {data?.members?.length == 0 ? (
          <div>
            <p className="text-[14px] text-red-500">No member assign yet</p>
          </div>
        ) : (
          <div>
            <div className="avatar-group -space-x-5 rtl:space-x-reverse">
              <div className="avatar">
                <div className="w-7">
                  <img src="https://daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                </div>
              </div>
              <div className="avatar">
                <div className="w-7">
                  <img src="https://daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                </div>
              </div>
              <div className="avatar">
                <div className="w-7">
                  <img src="https://daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                </div>
              </div>
              <div className="avatar placeholder">
                <div className="w-7 bg-neutral text-neutral-content">
                  <p className="text-center">
                    {/* <span className="font-medium"> Member: </span> */}
                    {data?.members?.length}
                  </p>
                </div>
              </div>
            </div>{" "}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamCreateCard;
